import Vue from 'vue'
import Router from 'vue-router'
import SPColumn from '@/components/SPColumn'
import SPContainer from '@/components/SPContainer'
import SPRow from '@/components/SPRow'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'SPColumn',
            component: SPColumn
        },
        {
            path: '/',
            name: 'SPContainer',
            component: SPContainer
        },
        {
            path: '/',
            name: 'SPRow',
            component: SPRow
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js